import { Outlet, useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import jwtDecode from "jwt-decode";
import { generateAuthUrl, getAccessToken } from "./utils";

const Authenticate = () => {
  const [error, setError] = useState('');
  let [searchParams] = useSearchParams();

  const [userData, setUserData] = useState({});

  const decodeIdToken = (token) => jwtDecode(JSON.stringify(token));

  const fixUserData = (data: any) => {
    if (typeof data === "string") return JSON.parse(data);
    if (typeof data === "object") {
      Object.keys(data).forEach((key) => {
        if (typeof data[key] === "string" && data[key].startsWith("[{")) {
          try {
            data[key] = JSON.parse(data[key]);
          } catch (e) {
            console.error("Error parsing", key, e);
          }
        }
      });
    }
    return data;
  };

  useEffect(() => {
    if (searchParams.get("error")) {
      setError(searchParams.get("error"));
    }

    if (!searchParams.get("code")) {
      const authUrl = generateAuthUrl();
        window.location.assign(authUrl);
    }

    if (searchParams.get("code")) {
      const value = searchParams.get("code");
      localStorage.setItem("code", value);

      getAccessToken(searchParams.get("code"))
        .then((tokenResponse) => {
          const { id_token, access_token, refresh_token } = tokenResponse;
          localStorage.setItem("accessToken", access_token);
          localStorage.setItem("refreshToken", refresh_token);
          localStorage.setItem("idToken", id_token);
          let decodedData = decodeIdToken(id_token);
          decodedData = fixUserData(decodedData);
          if ("params" in decodedData) {
            setUserData(decodedData);
          }else{ 
              setError("Access Denied to user for this app");
          }
        })
        .catch((err) => {
          const id_token = localStorage.getItem("idToken");
          if(id_token) {
            let decodedData = decodeIdToken(id_token);
            decodedData = fixUserData(decodedData);
            if ("params" in decodedData){
              setUserData(decodedData);
            }else{ 
                setError("Access Denied to user for this app");
            }
          }
          console.log("Error: 🤦‍♀️", err);
        });
    }
  }, [searchParams]);

  return (
    <div style={{ color: "white" }}>
      {error ? (
        <div style={{ color: "black" }}>
          {error}
        </div>
      ) : (
        <>Loading...</>
      )}
      {userData &&
        typeof userData === "object" &&
        Object.keys(userData).length > 0 && (
          <div>
            <span>Hi are you there</span>
            <pre
              style={{ color: "white", background: "#333", padding: "10px" }}
            >
              {JSON.stringify(userData, null, 2)}
            </pre>
          </div>
        )}

      <Outlet />
    </div>
  );
};

export default Authenticate;
